/* eslint-disable @typescript-eslint/no-explicit-any */
export default function sanitize(obj: any) {
  const objDraft = { ...obj };
  Object.keys(objDraft).forEach(
    (key) =>
      (objDraft[key] == null || objDraft[key] === '') && delete objDraft[key]
  );
  return objDraft;
}
